import React, { useEffect, useState } from 'react'
import { leadHistory } from '../../../Context/api';
import axios from 'axios';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { toast, ToastContainer } from 'react-toastify';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import Spinner from '../../Spinner/spinner';

const LeadHistory = () => {
    const [listData, setListData] = useState([]);
    const [spinner, setSpinner] = useState(false)
    const { id } = useParams()
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    useEffect(() => {
        history()
    }, [])

    const history = () => {
        setSpinner(true)
        axios.post(leadHistory(), { leadId: id,createdbyId:adminData?.userId },).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setListData(resp.data.data);
                setSpinner(false)
            }
            else {
                setListData([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })

    };
    return (
        <section>
            <ToastContainer />
            <div className="cus-padd cusheight">
                {spinner ? <Spinner /> : null}
                <header>
                    <h2 className='page-tittle'>
                        Lead History
                    </h2>
                    <hr />
                </header>
                <div className="timeline">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {
                                    listData?.map((item) =>
                                        <div className="timeline-container">
                                            <div className="timeline-end">
                                                <p>{moment(item?.createdAt).format('DD-MM-YYYY')}</p>
                                            </div>
                                            <div className="timeline-continue">
                                                <div className="row timeline-right">
                                                    <div className="col-md-6">
                                                        <p className="timeline-date">
                                                            {item?.status == 'UPDATEDETAIL' ? 'Update Details' : item?.status == 'COMPLETED' ? 'Completed'
                                                                : item?.status == 'ASSIGNMARKETINGTEAM' ? 'Assign Marketing Team' : item?.status == 'LEAD' ? 'Lead' : item?.status == 'PROVIDERCREATED' ? 'Provider Created' : item.status}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="timeline-box shadow">
                                                            <div className="timeline-icon">
                                                            </div>
                                                            <div className="timeline-text">
                                                                <p>Name - {item.name}</p>
                                                                <p>Business Name - {item.providerName}</p>
                                                                <p>Email - {item.email}</p>
                                                                <p>Mobile No - {item.mobileNo}</p>
                                                                <p>Lead Number - {item.leadNumber}</p>
                                                                <p style={{ wordBreak: 'break-word' }}>Description - {item.description}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LeadHistory